import { colors } from "@libertify/ui";

const WORKSPACE_COVERS = [
  `linear-gradient(135deg, ${colors.primary[300]}, ${colors.secondary[500]})`,
  `linear-gradient(135deg, ${colors.info[300]}, ${colors.primary[700]})`,
  `linear-gradient(135deg, ${colors.brandkit[200]}, ${colors.info[700]})`,
  `linear-gradient(135deg, ${colors.warning[300]}, ${colors.error[500]})`,
  `linear-gradient(135deg, ${colors.primary[200]}, ${colors.info[500]})`,
  `linear-gradient(135deg, ${colors.error[200]}, ${colors.secondary[400]})`,
  `linear-gradient(135deg, ${colors.success[200]}, ${colors.primary[600]})`,
  `linear-gradient(135deg, ${colors.brandkit[400]}, ${colors.secondary[600]})`,
  `linear-gradient(135deg, ${colors.warning[200]}, ${colors.primary[500]})`,
  `linear-gradient(135deg, ${colors.info[200]}, ${colors.error[400]})`,
];
export const getCoverImage = (workspaceId: string) => {
  // Hash workspace ID to get consistent index
  const hash = workspaceId.split("").reduce((a, b) => {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0);
  const index = Math.abs(hash) % WORKSPACE_COVERS.length;
  return WORKSPACE_COVERS[index];
};
